module.exports = __webpack_public_path__ + "media/images/payments/verifone-6ce099dc3b7955ef699eacef227ce1f6.svg";